const catering = [
  {
    id: "catering",
    isInline: true,
    title: {
      es: "Catering oficial",
      cat: "Catering oficial",
    },
    items: [
      {
        link: {
          es: "https://variatmallorca.es/",
          cat: "https://variatmallorca.es/",
        },
        title: "Variat",
        image: "catering-variat.png",
        size: 1,
        original: true,
      },
    ],
  },
];

export default catering;
